import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import {
  realmInfoRequest,
  getConsent,
  postConsentAcceptance,
  clearRealmInfo,
} from 'app/pages/login/actions'
import {
  getRealmInfo,
  getConsentInfo,
  getConsentAccepted,
} from 'app/pages/login/selectors'
import * as FormElements from 'app/components/form/FormElements'
import SubmitButton from 'app/components/SubmitButton'
import { Divider } from 'app/components/Panel.jsx'

const LayoutHolder = styled.div`
  position: relative;
  max-height: 70%;
  min-height: 40%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

const TextHolder = styled.p`
  width: 100%;
  max-height: 80%;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  white-space: pre-line;
  &::-webkit-scrollbar {
    width: 1.2rem;
  }

  &::-webkit-scrollbar-track {
    background: #fffcfa;
  }

  &::-webkit-scrollbar-thumb {
    border: 0.35rem solid #fffcfa;
    background-color: #d8d8d8;
    border-radius: 0.7rem;
  }
`
const ConsentView = ({
  realmInfoRequest,
  realmInfo,
  consentInfo,
  postConsentAcceptance,
  isConsentAccepted,
  clearRealmInfo,
  getConsent,
}) => {
  useEffect(() => {
    clearRealmInfo()
    realmInfoRequest()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getConsentData = useCallback(() => {
    const realmAddress = realmInfo.address
    if (realmAddress) getConsent(realmAddress)
  }, [realmInfo, getConsent])

  useEffect(() => {
    getConsentData()
  }, [realmInfo, getConsentData])

  useEffect(() => {
    if (isConsentAccepted) {
      const realmAddress = realmInfo.address
      const successful_login_url = `${realmAddress}/concierge/session/redirect`
      window.location = successful_login_url
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConsentAccepted])

  const handleSubmit = () => {
    const realmAddress = realmInfo.address

    postConsentAcceptance(realmAddress, consentInfo.uuid)
  }

  if (!consentInfo.uuid)
    return (
      <FormElements.LoginRow>
        <p>Loading...</p>
      </FormElements.LoginRow>
    )
  return (
    <LayoutHolder>
      <TextHolder>{consentInfo.text}</TextHolder>
      <Divider minHeight={'4rem'} />
      <SubmitButton onClick={() => handleSubmit()} primary>
        I Accept
      </SubmitButton>
    </LayoutHolder>
  )
}

ConsentView.propTypes = {
  realmInfoRequest: PropTypes.func,
  realmInfo: PropTypes.object,
  consentInfo: PropTypes.object,
  postConsentAcceptance: PropTypes.func,
  isConsentAccepted: PropTypes.bool,
  clearRealmInfo: PropTypes.func,
}

const mapStateToProps = (state) => ({
  realmInfo: getRealmInfo(state),
  consentInfo: getConsentInfo(state),
  isConsentAccepted: getConsentAccepted(state),
})

export default connect(mapStateToProps, {
  realmInfoRequest,
  getConsent,
  postConsentAcceptance,
  clearRealmInfo,
})(ConsentView)
